import DocumentsVerification from './documents-verification';

export default DocumentsVerification;
